<template>
  <div class="indexContainner" >
    <dv-full-screen-container>
      <div class="contain" :class="isLq =='lq'?'lqS':'swS'">
        <el-container style="height:100%">
          <el-header>
            <el-row style="height:100%">
              <el-col :span="9">
                <el-col :span="15" class="header-1">
                  <el-select
                    :popper-append-to-body="false"
                    popper-class="select-E"
                    v-model="engineeringVal"
                    @change="changeEngineer"
                    filterable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in engineeringList"
                      :key="item.id"
                      :label="item.engineeringName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="9" class="header-2">
                  <el-select
                    :popper-append-to-body="false"
                    popper-class="select-S"
                    v-model="sectionVal"
                    @change="changeSection"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in sectionList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-col>
              <el-col :span="6" >
                <!-- <div class="middleStr">沥青路面施工综合展示系统</div> -->
              </el-col>
              <el-col :span="9">
                <el-col
                  :span="7"
                  class="header-3"
                  :class="isLq == 'lq' ? 'lqLight' : 'lqDark'"
                >
                  <div @click="selectType('lq')" class="type-writing">
                    沥青面层
                  </div>
                </el-col>
                <el-col
                  :span="7"
                  class="header-4"
                  :class="isLq == 'sw' ? 'swLight' : 'swDark'"
                >
                  <div @click="selectType('sw')" class="type-writing">
                    水稳基层
                  </div>
                </el-col>
                <el-col :span="5" class="header-5">
                  <img
                    src="../assets/img/title-icon-time@2x.png"
                    alt=""
                    class="littleLogo"
                  />
                  <div class="writingCon">
                    <div class="big-writing">{{ currentDate }}</div>
                    <div class="small-writing">{{ currentTime }}</div>
                  </div>
                </el-col>
                <el-col :span="5" class="header-5">
                  <img :src="weatherLogo" alt="" class="littleLogo" />
                  <div class="writingCon">
                    <div class="big-writing">
                      {{ temperatureLower }}
                      <!-- {{ temperatureLower+'~'+temperatureUp }} -->
                       <span>°C</span>
                    </div>

                    <div class="small-writing">{{ weatherSynopsis }}</div>
                  </div>
                </el-col>
              </el-col>
            </el-row>
          </el-header>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
        <videoBox></videoBox>
      </div>
    </dv-full-screen-container>
    <a href='https://beian.miit.gov.cn/' target='_blank' style='cursor: pointer;color: #fff;position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);z-index: 999;'>苏ICP备11019701号</a>
  </div>
</template>

<script>
var cookie = {
	set:function(key,val,time){//设置cookie方法
		var date=new Date(); //获取当前时间
		var expiresDays=time;  //将date设置为n天以后的时间
		date.setTime(date.getTime()+expiresDays*24*3600*1000); //格式化为cookie识别的时间
		document.cookie=key + "=" + val +";expires="+date.toGMTString();  //设置cookie
	},
	get:function(key){//获取cookie方法
		/*获取cookie参数*/
		var getCookie = document.cookie.replace(/[ ]/g,"");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
		var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
		var tips;  //声明变量tips
		for(var i=0;i<arrCookie.length;i++){   //使用for循环查找cookie中的tips变量
			var arr=arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
			if(key==arr[0]){  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
				tips=arr[1];   //将cookie的值赋给变量tips
				break;   //终止for循环遍历
			}
		}
		return tips;
	}
}
import { mapState } from "vuex";
import videoBox from '../subassembly/video'
import {
  loginSystem,
  getListEngineer,
  getListSection,
  getListWorkArea,
  getSectionDetail,
  getWeather,
  getInitScreenData,
  getListWorkAreaE
} from "@/api/api";
export default {
   components: {
        videoBox
    },
  data() {
    return {
      currentTime: "",
      currentDate: "",
      weatherSynopsis: "",
      temperatureLower: "",
      temperatureUp:"",
      isLq: "lq",
      weatherLogo: require("../assets/img/title-iconweather@2x.png"),
      engineeringList: [],
      sectionList: [],
      engineeringVal: "",
      units: {
        introduction: "",
        Participation: "",
        construction: "",
        supervisor: "",
        Design: ""
      },
      sectionVal: "",
      sess:""
    };
  },
  created() {},
  mounted() {
     var that = this ;
    setInterval(() => {
      this.NumberFix();
    }, 1000);
    this.login();
  },
  methods: {
    // 获取温度风速
    async getTW(workId) {
      let req = {
        engineeringConfigId:workId
      };
      const ertData = await getInitScreenData(req);
      console.log(ertData)
      console.log(workId)
      if (ertData.status == 200) {
        console.log(ertData)
        this.temperatureLower=Number(ertData.data.resultData.envTemperature).toFixed(0)
      }
    },
    async login() {
      console.log(window.location.hash.split("?")[0].split('/')[1])
      if(window.location.hash.split("?")[0].split('/')[1] == 'swLayer') {
        this.isLq = 'sw'
      }else {
        this.isLq = 'lq'
      }
      if(window.location.hash.split("?")[1]) {
        let hashUrl = window.location.hash.split("?")[1].split("&");
      let val = [];
      hashUrl.forEach((item, i) => {
        val.push(item.split("=")[1]);
      });
      this.userName = val[0];
      this.password = val[1];
      sessionStorage.setItem("userName",this.userName)
      sessionStorage.setItem("password",this.password)
      }

      // this.$store.commit("updataUserName", this.userName);
      // this.$store.commit("updataPassword", this.password);
      let un = sessionStorage.getItem("userName");
      let pw = sessionStorage.getItem("password");
      let req = {
        username:un,
        password: pw
      };
      const data = await loginSystem(req);
         this.getEngineer();
    },
    // 获取工程
    async getEngineer() {
      const engData = await getListEngineer();
      if (engData.status == 200) {
        this.engineeringList = engData.data;
        this.engineeringVal = engData.data[0].id;
        this.$store.commit("updataEngineerId", this.engineeringVal);
        this.getSection();
        this.SectionDetail(this.sess);
        this.getWeather();
        this.units = {
          introduction: engData.data[0].engingeeringIntro,
          Participation: engData.data[0].constructionCompany.name
        };
      }
      this.$store.commit("updataIntroduction", this.units.introduction);
      this.$store.commit("updataParticipation", this.units.Participation);

    },
    // 获取工程下标段
    // async getSection() {
    //   this.sectionList = [];
    //   this.sectionVal = "";
    //   let req = {
    //     engId: this.engineeringVal,
    //     mType: this.isLq
    //   };
    //   const secData = await getListSection(req);
    //   this.sectionList = secData.data;
    //   this.sectionVal = secData.data.length > 0 ? secData.data[0].id : "";
    //   this.$store.commit("updataSectionId", this.sectionVal);
    //   sessionStorage.setItem("sectionName", secData.data.length > 0?secData.data[0].sectionName:'');
    //   this.SectionDetail(this.sectionVal);
    //   this.getWorkArea()
    // },
    // 根据工程查工区
    async getSection() {
      this.sectionList = [];
      this.sectionVal = "";
      let req = {
        engId: this.engineeringVal,
        mType:this.isLq
      };
      const secData = await getListWorkAreaE(req);
      console.log(secData)
      this.sectionList = secData.data;
      this.sectionVal = secData.data.length > 0 ? secData.data[0].id : "";
      this.sess = secData.data[0].section.id
       this.$store.commit("updataSeIds", this.sess);
      this.$store.commit("updataSectionId", this.sectionVal);
      sessionStorage.setItem("sectionName", secData.data.length > 0?secData.data[0].sectionName:'');
      this.SectionDetail(this.sess);
      this.getTW(this.sectionVal)
      // this.getWorkArea()
    },
    // 获取工区
    async getWorkArea() {
      let req = {
        sectionId: this.sectionVal,
        workAreaType:this.isLq
      };
      const waData = await getListWorkArea(req);
      if(waData.data.length>0) {
        // this.getTW(waData.data[0].id)
        // this.$store.commit("updataWorkAreaId", waData.data[0].id);
      }else {
        // this.$store.commit("updataWorkAreaId", '');
      }
      // sessionStorage.setItem("workAreaId", waData.data[0].id);
    },
    async SectionDetail(id) {
      if (id == "") {
      } else {
        let req = {
          sectionId: id
        };
        const sdData = await getSectionDetail(req);

        this.units = {
          construction: sdData.data.constructionOfficeList[0]
            ? sdData.data.constructionOfficeList[0].name
            : "",
          supervisor: sdData.data.controlOfficeList[0]
            ? sdData.data.controlOfficeList[0].name
            : "",
          Design: sdData.data.designOfficeList[0]
            ? sdData.data.designOfficeList[0].name
            : ""
        };
        this.$store.commit("updataConstruction", this.units.construction);
        this.$store.commit("updataSupervisor", this.units.supervisor);
        this.$store.commit("updataDesign", this.units.Design);
      }
    },
    // 获取天气信息
    async getWeather() {
      let req = {
        engineeringId: this.engineeringVal
      };
      const weaData = await getWeather(req);
      console.log(weaData)
      // this.temperatureLower = weaData.data.tem2;
      // this.temperatureUp = weaData.data.tem1;
      this.weatherSynopsis = weaData.data.stateDetailed?weaData.data.stateDetailed:"";
      if(this.weatherSynopsis.indexOf('晴') >= 0) {
        this.weatherLogo = require("../assets/img/title-iconweather@2x.png")
      }else if(this.weatherSynopsis.indexOf('雷') >= 0) {

      }else if(this.weatherSynopsis.indexOf('雨') >= 0) {

      }else if(this.weatherSynopsis.indexOf('雪') >= 0) {

      }else {

      }
    },
    // 获取当前时间
    NumberFix() {
      const val = new Date();
      const y = val.getFullYear();
      const m = (val.getMonth() + 1).toString().padStart(2, "0");
      const d = val
        .getDate()
        .toString()
        .padStart(2, "0");
      const h = val
        .getHours()
        .toString()
        .padStart(2, "0");
      const mi = val
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const s = val
        .getSeconds()
        .toString()
        .padStart(2, "0");
      this.currentTime = `${y}-${m}-${d}`;
      this.currentDate = `${h}:${mi}:${s}`;
      // 2020-05-19+10:11:00
    },
    async changeEngineer(val) {
      this.getWeather();
      this.getSection();
      // this.SectionDetail(this.sectionVal)
      this.$store.commit("updataEngineerId", val);
      this.engineeringList.forEach(item => {
        if (item.id == val) {
          this.$store.commit("updataIntroduction", item.engingeeringIntro);
          this.$store.commit(
            "updataParticipation",
            item.constructionCompany.name
          );
        }
      });
    },
    changeSection(val) {
       console.log(val)
       this.$store.commit("updataSectionId", val);
       let sectionNID = this.sectionList.filter(item => item.id==val)[0].section.id
       this.$store.commit("updataSeIds", sectionNID);
       this.$store.commit("updataWorkAreaId", sectionNID);
       // this.getWorkArea(val)
       this.getTW(val);
    },
    // 类型切换
    selectType(type) {
      this.isLq = type;
      this.getSection();
      if (type == "lq") {
        this.$router.push({ path: "/lqLayer", query: { } });
      } else {
        this.$router.push({ name: "swLayer", params: { aa: "xx", bb: "xx" } });
      }
    }
  },
  computed: mapState([
    "engineerId",
    "sectionId",
    "introduction",
    "Participation",
    "construction",
    "supervisor",
    "Design"
  ])
};
</script>
<style lang="less" scoped>
.lqS {
  background-image: url(../assets/img/lqBgNew.png);
  //background-image: url(../assets/img/bg55.jpg);//润程
}
.swS {
  background-image: url(../assets/img/swBgNew.png);
//background-image: url(../assets/img/bg33.jpg);//润程
}
.indexContainner {
  .contain {
    height: 100%;
    width: 100%;
    // background-image: url(../assets/img/bg33.jpg);
    background-size: 100% 100%;
  }
  .el-header {
    height: 65px !important;
    .el-row {
      .el-col-8,
      .el-col-9,
      .el-col-6,
      .el-col-15,
      .el-col-5,
      .el-col-7,
      .el-col-4 {
        height: 100%;
        margin-top: 10px;
      }
      .header-1 {
        background-size: 100% 80%;
        background-repeat: no-repeat;
        background-image: url(../assets/img/title-engineering@2x.png);
      }
      .header-2 {
        margin-left: -28px;
        background-size: 100% 80%;
        background-repeat: no-repeat;
        background-image: url(../assets/img/title-bidsection@2x.png);
      }
      .header-3 {
        margin-left: 28px;
        margin-right: -30px;
        background-size: 100% 80%;
        background-repeat: no-repeat;
      }
      .header-4 {
        background-size: 100% 80%;
        background-repeat: no-repeat;
      }
      .header-5 {
        .littleLogo {
          float: left;
          width: 20px;
          height: 20px;
          margin-top: 4px;
          margin-left: 20px;
        }
        .writingCon {
          float: left;
          margin-left: 6px;
          .big-writing {
            font-size: 22px;
            font-family: Fantasy;
            color: #fff;
            span {
              font-family: Serif;
              font-size: 16px;
              font-weight: 600;
            }
          }
          .small-writing {
            font-size: 15px;
            font-family: Serif;
            color: #fff;
          }
        }
      }
      .type-writing {
        cursor: pointer;
        text-align: center;
        margin-left: 20px;
        line-height: 44px;
        height: 60%;
        font-size: 16px;
      }
    }
  }
  .lqLight {
    background-image: url(../assets/img/title-asphalt-select@2x.png);
    color: #fff721;
  }
  .lqDark {
    background-image: url(../assets/img/title-asphalt@2x.png);
    color: #fff;
  }
  .swLight {
    background-image: url(../assets/img/title-waterstability-select@2x.png);
    color: #fff721;
  }
  .swDark {
    background-image: url(../assets/img/title-waterstability@2x.png);
    color: #fff;
  }
  .el-main {
    padding: 20px;
    padding-top: 6px;
  }
}
</style>
<style lang="less">
.indexContainner {
  .el-col-15 {
    .el-select {
      width: 380px;
      margin-left: 30px;
    }
    .el-input {
      width: 360px !important;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .el-input--suffix .el-input__inner {
      // padding-right: 0.6rem;
      background: rgba(0, 0, 0, 0);
      color: #fff !important;
      border: none;
      width: 360px !important;
      // padding-bottom: 6px;
      // margin-left: 30px !important;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .el-col-9 {
    .el-select {
      width: 188px;
      margin-left: 25px;
    }
    .el-input {
      width: 190px;
      overflow: hidden;
      margin-left: 30px !important;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .el-input--suffix .el-input__inner {
      // padding-right: 0.6rem;
      background: rgba(0, 0, 0, 0);
      color: #fff !important;
      border: none;
      width: 190px;
      // padding-bottom: 6px;
      // margin-left: 30px;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  // .el-input__inner:nth-of-type(1) {
  //   margin-left: 32px;
  // }
  .el-select .el-input .el-select__caret {
    color: yellow;
  }
  .el-icon-arrow-up:before {
    content: "\e78f";
  }
}
.select-E {
  left: 42px !important;
  width: 400px !important;
  min-width: 10px !important;
}
.select-S {
  min-width: 10px !important;
  width: 256px !important;
  left: 452px !important;
}
.el-select-dropdown__item {
  color: #fff;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: rgba(7, 21, 68, 0.3);
}
.el-select-dropdown {
  background: rgba(7, 21, 68, 1);
  border: none;
}
.el-select-dropdown el-popper:nth-of-type(1) .el-select-dropdown {
  left: 100px !important;
}
.el-popper .popper__arrow::after {
  border-bottom-color: rgba(7, 21, 68, 0.3) !important;
}
.el-popper .popper__arrow {
  border-bottom-color: rgba(7, 21, 68, 0) !important;
}
.el-select-dropdown__item {
  width: 100% !important;
}
.middleStr {
  color:#fff;
  background-color: #0a1b4d;
  font-size: 40px;
  letter-spacing: 10;
  font-weight: 700;
  font-style: italic;
margin-left: 58px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue